export const COMPANY_BRANCH_STATUS_ACTIVE = 'active'
export const COMPANY_BRANCH_STATUS_LOGGED_OUT = 'logged_out'
